import {
  ChangeDetectionStrategy,
  Component,
  Signal,
  signal,
  viewChild,
  WritableSignal,
  inject,
} from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, Router } from '@angular/router';
import { TabsetComponent } from '@appkit4/angular-components/tabs';
import { ModalService } from '@shared/services';
import { tap } from 'rxjs';
import { adminMenuItems, adminRoutes } from '../../constants';
import { AdminMenuItem } from '../../models';

@Component({
  standalone: false,
  selector: 'gstar-admin-tabs-page',
  templateUrl: 'admin-tabs-page.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AdminTabsPageComponent {
  private readonly router = inject(Router);
  private readonly modalService = inject(ModalService);
  readonly activatedRoute = inject(ActivatedRoute);

  tabIndex: WritableSignal<number> = signal(0);
  public adminMenuItems: AdminMenuItem[] = adminMenuItems;

  tab: Signal<TabsetComponent | undefined> =
    viewChild<TabsetComponent>('tabset');

  constructor() {
    this.activatedRoute
      .firstChild!.url.pipe(
        takeUntilDestroyed(),
        tap(url =>
          this.tabIndex.set(
            adminMenuItems.findIndex(item =>
              url.find(segment => item.route === segment.path)
            )
          )
        )
      )
      .subscribe();
  }

  tabChange(index: number): Promise<boolean> {
    const item = this.adminMenuItems[index];
    if (!this.isRouterRedirectionNeeded(item) && item.modalComponent) {
      this.modalService.open(item.modalComponent, {
        appModalId: signal(item.titleTranslateKey),
      });
      this.revertTabsetActiveChange();
      return Promise.resolve(false);
    }
    this.tabIndex.set(index);
    return this.router.navigate([
      adminRoutes.root,
      this.adminMenuItems[index].route,
    ]);
  }

  isRouterRedirectionNeeded = (item: AdminMenuItem): boolean =>
    item.route !== '';

  revertTabsetActiveChange = (): void =>
    this.tab()?.setTabActive(this.tabIndex());
}
